export type ClientPlatformTypeType =
  | 'CLIENT_PLATFORM_TYPE_UNKNOWN'
  | 'CLIENT_DESKTOP'
  | 'CLIENT_MOBILE_WEB'
  | 'APP_IOS'
  | 'APP_ANDROID'
  | 'APP_OTHER';

/**
 * The type of mobile app
 */
export enum ClientPlatformType {
  CLIENT_PLATFORM_TYPE_UNKNOWN = 'CLIENT_PLATFORM_TYPE_UNKNOWN',
  CLIENT_DESKTOP = 'CLIENT_DESKTOP',
  CLIENT_MOBILE_WEB = 'CLIENT_MOBILE_WEB',
  APP_IOS = 'APP_IOS',
  APP_ANDROID = 'APP_ANDROID',
  APP_OTHER = 'APP_OTHER',
}
